// import { SET_FILTERS_CASE } from "constants/ActionTypes"

export const setFilterCases = ( filters ) => {
  return {
    type    : 'SET_FILTERS_CASE_SAGA',
    payload : filters

  };
};
